import { Controller } from "@hotwired/stimulus"

// Parallax shrink + fade on scroll.
// Effect is complete after scrolling ~60% of viewport height so it's
// immediately visible even on small scroll amounts.
//
// Uses window.scrollY directly — the hero is always pinned to the top of the
// page so scrollY == "pixels scrolled past the hero". This avoids offsetTop
// (relative to offsetParent, wrong when a positioned ancestor exists) and
// getBoundingClientRect caching (wrong when called before layout completes).

export default class extends Controller {
  connect() {
    this.ticking   = false
    this.threshold = window.innerHeight * 0.6   // full effect after 60vh scrolled

    this.boundOnScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.boundOnScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundOnScroll)
    this.element.style.transform = ""
    this.element.style.opacity   = ""
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true

    requestAnimationFrame(() => {
      const scrolled = window.scrollY
      const progress = Math.min(1, scrolled / this.threshold)

      // scale: 1.0 → 0.88  |  translateY: 0 → -100px  |  rotateX: 0 → 15deg  |  opacity: 1 → 0.1
      const scale      = 1 - progress * 0.35
      const translateY = -(progress * 100)
      const rotateX    = progress * 15
      const opacity    = 1 - progress * 1

      this.element.style.transform = `scale(${scale}) translateY(${translateY}px) rotateX(${rotateX}deg)`
      this.element.style.opacity   = opacity

      this.ticking = false
    })
  }
}
